import { AnimateHeight } from '../animate-height';
import useToggle from '../../../utilities/useToggle';

export interface AccordionButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  active: boolean;
}

interface BodyProps {
  active: boolean;
}

interface AccordionProps {
  Button: React.ElementType<AccordionButtonProps>;
  Body: React.ElementType<BodyProps>;
  initialState?: boolean;
  isDefaultOpen?: boolean;
}

export const Accordion = ({
  Button,
  Body,
  initialState = false,
  isDefaultOpen = false,
}: AccordionProps) => {
  const [isOpen, toggle] = useToggle(initialState || isDefaultOpen);

  return (
    <>
      <Button onClick={() => toggle()} active={isOpen} />
      <AnimateHeight expanded={isOpen}>
        <Body active={isOpen} />
      </AnimateHeight>
    </>
  );
};
